import {Component, OnInit, AfterViewInit, Input, Output, ViewEncapsulation, Inject, SimpleChanges  } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { AiCopilotService } from 'src/app/services/vendor/ai-copilot.service';
import { environment } from 'src/environments/environment';


@Component({
    selector: 'app-trial-notification-dialog.component',
    templateUrl: 'trial-notification-dialog.component.html',
    styleUrls: ['trial-notification-dialog.component.scss'],
    encapsulation: ViewEncapsulation.None
  })

export class TrialNotificationDialogComponent implements OnInit {

  public dialogTitle: string = "";
  public trialDuration: number = environment.trialDuration;
  
  constructor(
    public matDialogRef: MatDialogRef<TrialNotificationDialogComponent>, 
    @Inject(MAT_DIALOG_DATA) public trialDaysRemaining: number,
    private router: Router,
    public aiCopilotService: AiCopilotService
  ) {

  }

  ngOnInit() {
    this.matDialogRef.disableClose = true;
    this.dialogTitle = "Trial Notification"
  }

  ngOnChanges(changes: SimpleChanges): void {


  }

  ngOnDestroy() {

  } 

  public navigateToPlans(): void {
    this.router.navigate(['/hive/professional/admin-account/subscription']); 
    this.matDialogRef.close();
  }

  public close(): void {
    this.matDialogRef.close();
  }

}